import * as React from 'react';
import {
    FormGroup,
    ControlLabel,
    FormControl,
    Checkbox,
    HelpBlock,
    Panel,
    Col,
    Row
} from 'react-bootstrap';
import { IComment, IFilter } from '../Entities';
import { Translate } from '../../../../../shared/LanguageService';
import FormValidationService from '../../../../../shared/form/FormValidationService';
import * as Features from '../../../../../shared/Features';
import DateTimeView from '../../../../localDate/DateTimeView';

interface IImageProcessingCommentsSectionProps {
    filter: IFilter;
    comments: IComment[];
    comment: IComment;
    errors: any;
    onChange: (e: any) => void;
    latestImageId: number;
    shownImageId: number;
    user: any;
    role: number;
    hideImageEditor?: boolean;
    recipientIsObligatory?: boolean;
}

const ImageProcessingCommentsSection = (props: IImageProcessingCommentsSectionProps) => {
    return (
        <div>
            <Row>
                <Col xs={12}>
                    <h3>{Translate('image-processing/modal/comments/header-label/comments')}</h3>
                </Col>
            </Row>

            <div>
                {props.comments &&
                    props.comments.map((comment: IComment) => {
                        return (
                            <Panel key={comment.id}>
                                <Panel.Heading>
                                    <Panel.Title>
                                        {getCommentHeader(props.user, comment)}
                                    </Panel.Title>
                                </Panel.Heading>
                                <Panel.Body>{comment.text}</Panel.Body>
                            </Panel>
                        );
                    })}
            </div>
            {props.latestImageId === props.shownImageId && (
                <fieldset>
                    <legend className="required">
                        {Translate('image-processing/modal/comments/legend-label/comment')}
                    </legend>

                    <FormGroup
                        className="required"
                        validationState={FormValidationService.getValidationState(
                            props.errors.text
                        )}
                    >
                        <strong>
                            {Translate(
                                'image-processing/modal/comments/textarea-label/write-comment'
                            )}
                        </strong>
                        <FormControl
                            onChange={props.onChange}
                            name="comment.text"
                            componentClass="textarea"
                            value={props.comment.text ? props.comment.text : ''}
                        />
                        {props.errors.text && <HelpBlock>{props.errors.text}</HelpBlock>}
                    </FormGroup>
                    <FormGroup className="required">
                        {props.recipientIsObligatory && (
                            <ControlLabel>
                                {Translate(
                                    'image-processing/modal/comments/input-label/choose-recipient'
                                )}
                            </ControlLabel>
                        )}
                        {!props.recipientIsObligatory && (
                            <strong>
                                {Translate(
                                    'image-processing/modal/comments/input-label/choose-recipient'
                                )}
                            </strong>
                        )}
                    </FormGroup>
                    <Row>
                        <Col xs={12}>
                            <FormGroup
                                validationState={FormValidationService.getValidationState(
                                    props.errors.recipients
                                )}
                            >
                                {props.role !== 5 && (
                                    <Checkbox
                                        inline
                                        name="comment.toPhotographer"
                                        checked={
                                            props.comment ? props.comment.toPhotographer : false
                                        }
                                        onChange={props.onChange}
                                    >
                                        <span>
                                            {Translate(
                                                'image-processing/modal/comments/input-label/to-photographer'
                                            )}
                                        </span>
                                    </Checkbox>
                                )}
                                {props.hideImageEditor !== true && props.role !== 6 && (
                                    <Checkbox
                                        inline
                                        name="comment.toImageEditor"
                                        checked={
                                            props.comment ? props.comment.toImageEditor : false
                                        }
                                        onChange={props.onChange}
                                    >
                                        <span>
                                            {Translate(
                                                'image-processing/modal/comments/input-label/to-imageeditor'
                                            )}
                                        </span>
                                    </Checkbox>
                                )}
                                {props.role !== 1 && props.role !== 2 && props.role !== 11 && (
                                    <Checkbox
                                        inline
                                        name="comment.toSe360"
                                        checked={props.comment ? props.comment.toSe360 : false}
                                        onChange={props.onChange}
                                    >
                                        <span>
                                            {Translate(
                                                'image-processing/modal/comments/input-label/to-se360'
                                            )}
                                        </span>
                                    </Checkbox>
                                )}
                                {props.errors.recipients && (
                                    <HelpBlock>{props.errors.recipients}</HelpBlock>
                                )}
                            </FormGroup>
                        </Col>
                    </Row>
                </fieldset>
            )}
        </div>
    );
};

function getCommentHeader(user: any, comment: IComment) {
    let icon: JSX.Element;
    let personRecipientIcon: JSX.Element;
    let photographerRecipientIcon: JSX.Element;
    let editorRecipientIcon: JSX.Element;
    let se360RecipientIcon: JSX.Element;
    switch (comment.feature) {
        case Features.ViewCommentsForAll:
            icon = <i className="material-icons">headset_mic</i>;
            break;
        case Features.ViewCommentsForPhotographer:
            icon = <i className="material-icons">camera_alt</i>;
            break;
        case Features.ViewCommentsForImageEditor:
            icon = <i className="material-icons">color_lens</i>;
            break;
        default:
            break;
    }

    if (comment.toPhotographer) {
        photographerRecipientIcon = <i className="material-icons">camera_alt</i>;
    }

    if (comment.toImageEditor) {
        editorRecipientIcon = <i className="material-icons">color_lens</i>;
    }

    if (comment.toSe360) {
        se360RecipientIcon = <i className="material-icons">headset_mic</i>;
    }

    return (
        <span>
            {icon} {comment.author} <i className="material-icons">forward</i> {personRecipientIcon}
            {photographerRecipientIcon}
            {editorRecipientIcon}
            {se360RecipientIcon}{' '}
            <span className="pull-right">
                <DateTimeView dateTime={comment.time} />
            </span>
        </span>
    );
}

export default ImageProcessingCommentsSection;
